import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickHstack from '@/components/brick_hstack.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-square', 'text-green']
infos.front_classes = ['fas', 'fa-layer-group', 'fa-rotate-270', 'text-white']
infos.name = 'hstack'
infos.associated_class_name = 'AutomlHstackTable'
infos.editing_component_name = 'BrickHstack'
infos.editing_component = BrickHstack
infos.descriptions = {
	en: {
		short_tooltip_description: 'Horizontal stacking',
		full_tooltip_description:
			'Horizontal stacking of several tables (i.e. tables with the same number of rows)',
		navbar_name: 'Horizontal stacking',
	},
	fr: {
		short_tooltip_description: 'Empilement horizontal',
		full_tooltip_description:
			'Concaténation horizontale de plusieurs tables (i.e. avec le même nombre de lignes)',
		navbar_name: 'Empilement horizontal',
	},
}
// infos.short_tooltip_description = 'hstack_short_tooltip'
// infos.full_tooltip_description = 'hstack_full_tooltip'
// infos.navbar_name = 'hstack_navbar'
infos.background_color = 'green'

brick_registerer(infos)
